var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TagDisplay',{attrs:{"tags":_vm.tagObjects,"placeholder":_vm.placeholder,"button":_vm.button,"large":_vm.large},on:{"click":function($event){return _vm.$emit('click', $event.id)}}})}
var staticRenderFns = []

export { render, staticRenderFns }